var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Icones",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ic\\xF4nes",
    transform: "translate(-149.000000, -372.000000)",
    fill: "#04246A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components-/-02-Icon-/-16-/-Download",
    transform: "translate(149.000000, 372.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M8,1 C4.13400675,1 1,4.13400675 1,8 C1,11.8659932 4.13400675,15 8,15 C11.8659932,15 15,11.8659932 15,8 C15,4.13400675 11.8659932,1 8,1 Z M8.2843055,4.58859116 L8.35355339,4.64644661 L11.3535534,7.64644661 C11.5488155,7.84170876 11.5488155,8.15829124 11.3535534,8.35355339 C11.179987,8.52711974 10.9105626,8.54640489 10.7156945,8.41140884 L10.6464466,8.35355339 L8.5,6.207 L8.5,12 C8.5,12.2761424 8.27614237,12.5 8,12.5 C7.75454011,12.5 7.55039163,12.3231248 7.50805567,12.0898756 L7.5,12 L7.5,6.207 L5.35355339,8.35355339 C5.17998704,8.52711974 4.91056264,8.54640489 4.7156945,8.41140884 L4.64644661,8.35355339 C4.47288026,8.17998704 4.45359511,7.91056264 4.58859116,7.7156945 L4.64644661,7.64644661 L7.64644661,4.64644661 C7.82001296,4.47288026 8.08943736,4.45359511 8.2843055,4.58859116 Z",
    id: "Combined-Shape",
    transform: "translate(8.000000, 8.000000) scale(1, -1) translate(-8.000000, -8.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.50ad15fe4ff8708ad096cac714679977.svg";
export { ForwardRef as ReactComponent };